import { useSearchParams } from 'react-router-dom';
import { capitalize } from '../utils/utils';

function useQueryParams() {
  const [searchParams] = useSearchParams();
  let isPaid = null;

  // Extract relevant query parameters and filter out empty values
  const paramList = [
    capitalize(searchParams.get('style')),
    capitalize(searchParams.get('q')),
  ].filter(Boolean);

  // Join parameters with '&' if there are multiple, or with '' if there's only one
  const queryData = paramList.join(paramList.length > 1 ? '&' : '');
  if (searchParams.get('price')) {
    isPaid = capitalize(searchParams.get('price')) !== 'Free';
  }
  return { paramList, queryData, isPaid };
}

export default useQueryParams;
